import { cloneDeep } from '@apollo/client/utilities';
import { applyMixins } from '../../util/mixins';
import { AssetLocation, AssetProduct } from '../asset/asset';
import { CompanyEntity } from '../common/entity';
import { WithCustomFields } from '../custom_field/customField';

export enum AssetTransactionType {
  outbound = 'outbound',
  inbound = 'inbound',

  verify = 'verify',
}

export enum AssetTransactionStatus {
  created = 'created',
  pending = 'pending',
  completed = 'completed',
}

export enum AssetTransactionParentType {
  assign = 'assign',
  returnAsset = 'returnAsset',
  upload = 'upload',
  manual = 'manual',
  reassign = 'reassign',

  ownership = 'ownership',
}

export class AssetTransaction extends CompanyEntity {
  status: AssetTransactionStatus = AssetTransactionStatus.created;
  type!: AssetTransactionType;
  product!: AssetProduct;
  location?: AssetLocation;
  processedBy?: string;
  processedAt?: Date;
  assetId?: string;
  parentType!: AssetTransactionParentType;
  parentId!: string;
  identifier?: string;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, cloneDeep(obj));
    this.customFields = WithCustomFields.toCustomFieldsMap(obj);
    this.product = new AssetProduct(this.product);
  }
}

export interface AssetTransaction extends WithCustomFields {}
applyMixins(AssetTransaction, [AssetTransaction, WithCustomFields]);
